// ============================================
// 📱 APP: NVA (React App)
// 📄 FILE: src/components/install/InstallAppCard.tsx
// 🔧 PURPOSE: "Installa l'app" in fondo alla Home, sempre lì finché l'app non
//   è installata (aperta come app, installata da qui, trovata da Chrome o
//   "L'ho già installata"): apre il foglio InstallAppSheet.
//   Da Safari l'iPhone non dice se l'app c'è già: il riquadro sparisce
//   aprendo l'app dall'icona o toccando "L'ho già installata".
// ============================================

import React from 'react';
import { useTranslation } from 'react-i18next';
import { Smartphone } from 'lucide-react';
import { CardShell, FOCUS_RING, IconCircle, INK_TEXT, MUTED_TEXT } from '../home/ui';
import { OPEN_INSTALL_EVENT } from '../../lib/installApp';
import { cn } from '../../lib/utils';
import { useInstallApp } from './useInstallApp';

const InstallAppCard: React.FC = () => {
  const { t } = useTranslation();
  const { installed, guide } = useInstallApp();
  if (installed || guide.kind === 'none') return null;
  return (
    <div className="px-4 pt-[18px]">
      <CardShell as="section" aria-labelledby="install-app-card-title" className="flex items-center gap-3 p-3.5">
        <IconCircle tone="ink" size={44}>
          <Smartphone />
        </IconCircle>
        <div className="flex min-w-0 flex-1 flex-col gap-px">
          <p id="install-app-card-title" className={cn('m-0 text-[15px] font-bold leading-snug', INK_TEXT)}>{t('installApp.card.title')}</p>
          <p className={cn('m-0 text-[13px] leading-snug', MUTED_TEXT)}>{t('installApp.card.text')}</p>
        </div>
        <button
          type="button"
          onClick={() => window.dispatchEvent(new Event(OPEN_INSTALL_EVENT))}
          className={cn(
            'min-h-[40px] flex-shrink-0 rounded-xl bg-nva-espresso px-3.5 text-[12px] font-extrabold uppercase tracking-button text-white dark:bg-stone-100 dark:text-stone-900',
            FOCUS_RING,
          )}
        >
          {t('installApp.card.button')}
        </button>
      </CardShell>
    </div>
  );
};

export default InstallAppCard;
